import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef } from 'react';
import useFlexStyles from '../../../hooks/use-flex-styles.esm.js';

var _excluded = ["testId", "as", "justify", "anchorClassName", "canShrink", "children", "className", "alignItems", "direction", "fit", "fullWidth", "fullHeight", "gap", "gapCol", "gapRow", "inline", "padding", "paddingX", "paddingY", "stretch"];
// import { usePropId } from '../../../utils/use-prop-id'

var Slot = /*#__PURE__*/forwardRef(function Slot(props, ref) {
  var testId = props.testId,
    _as = props.as,
    justify = props.justify,
    _props$anchorClassNam = props.anchorClassName,
    anchorClassName = _props$anchorClassNam === void 0 ? 'csg-tw-slot' : _props$anchorClassNam,
    canShrink = props.canShrink,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    alignItems = props.alignItems,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
    fit = props.fit,
    fullWidth = props.fullWidth,
    fullHeight = props.fullHeight,
    gap = props.gap,
    gapCol = props.gapCol,
    gapRow = props.gapRow,
    inline = props.inline,
    padding = props.padding,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    stretch = props.stretch,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = useFlexStyles({
    canShrink: canShrink,
    className: className,
    alignItems: alignItems,
    direction: direction,
    fit: fit,
    fullHeight: fullHeight,
    fullWidth: fullWidth,
    gap: gap,
    gapCol: gapCol,
    gapRow: gapRow,
    inline: inline,
    justify: justify,
    padding: padding,
    paddingX: paddingX,
    paddingY: paddingY,
    stretch: stretch
  });
  // const id = usePropId(props.id)
  var Component = _as !== null && _as !== void 0 ? _as : 'div';
  return /*#__PURE__*/React__default.createElement(Component
  // id={id}
  , _extends({
    ref: ref,
    "data-testid": testId,
    className: "".concat(anchorClassName, " ").concat(classes)
  }, rest), children);
});
Slot.displayName = 'Slot';
var Slot$1 = Slot;

export { Slot$1 as default };
//# sourceMappingURL=slot.esm.js.map
